import React from 'react';
import {
  downloadURI,
  getDesktopAppConfigForPlatform,
  getCurrentOS
} from '../../helpers/helpers';
import moment from 'moment';

const minutesAgoToCheck = 5;

const DesktopApp = class DesktopApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      finished: false,
      retryCount: 1,
      loading: false
    };
  }


  componentDidUpdate() {
    const { button, parent, statusClass, sessionStartData, syncDocumentData, store, sessionSid } = this.props;
    const { SessionStore } = store;
    const {desktopAppConnected, desktopAppRequestLoading} = SessionStore;
    let token = SessionStore.token;
    const { installSid} = sessionStartData.session;
    const examSid = sessionStartData.exam.sid;

    if (!token) {
      token = sessionStorage.getItem('token');
    }

    if (statusClass === 'slide-active') {
      // Skip if not enabled
      if (!sessionStartData.modalityOptions.desktopAppCheck) {
        parent.nextStep();
        button.disabled = false;
        return;
      }
      // If we have not connected to the desktop app continue
      // to retry pining the desktop app until connected
      if(!desktopAppConnected && !desktopAppRequestLoading){
        SessionStore.connectWithDesktopApp(token, sessionSid, installSid, examSid);
        // Setup the retry interval
        setTimeout(()=>{
          // Incrementing the retry count will call this method again until
          // the UI connects to the desktop app directly
          this.setState({retryCount: this.state.retryCount + 1});
        }, 5000);
      }
      // Check if we are running apps that are not allowed
      const hasBlockedApps = syncDocumentData
        && syncDocumentData.blockedApplications
        && syncDocumentData.blockedApplications.applications
        && syncDocumentData.blockedApplications.applications.length > 0;

      // Check if we are running on a vm
      const isRunningOnVm = syncDocumentData
        && syncDocumentData.vmDetected
        && syncDocumentData.vmDetected.vm === true;

      const timeAgo = moment().subtract(minutesAgoToCheck, 'minutes');
      // Check if the desktop app wrote to the sync doc at all
      // If we dont have the time stamps the desktop app didnt do the checks yet
      const desktopAppChecksReady = syncDocumentData
        && syncDocumentData.vmDetected
        && syncDocumentData.vmDetected.timestamp
        && moment(syncDocumentData.vmDetected.timestamp).isAfter(timeAgo)
        && syncDocumentData.blockedApplications
        && moment(syncDocumentData.blockedApplications.timestamp).isAfter(timeAgo);

      // Disable button if the desktop app is not ready, we are on vm or have blocked apps
      button.disabled = !desktopAppChecksReady || isRunningOnVm || hasBlockedApps || !desktopAppConnected;
    }
  }

  renderInstructions() {
    const translation = this.props.translation.desktopApp;
    const opSys = getCurrentOS()

    return <div>
      <h2 className="panel__title panel__title--alt">
        {translation.heading}
      </h2>

      <p>{translation.body}</p>

      <ol className="panel__list">
        <li>
          <p>{translation.steps.one}</p>

          <button
            className="btn"
            onClick={() => {
              const config = getDesktopAppConfigForPlatform();
              downloadURI(config.url, config.name);
            }}
          >
            {translation.buttons.download}
          </button>
        </li>
        <li>
          <p>{translation.steps.two}</p>
          
          <p>
            <img
              alt={translation.completed_download}
              className="img"
              src={(opSys !== "Mac") ? './static/img/windows_pinned_utility.png' : './static/img/pinned_utility_download.png'}
            />
          </p>
        </li>  
        <li>
          <p>{translation.steps.three[opSys]}</p>

          <p>
            <img
              alt={translation.installed_app}
              className="img"
              src={(opSys !== "Mac") ? './static/img/windows_utility_installation.jpeg' : "./static/img/utility_preview.png"}
            />
          </p>
        </li>
        <li>
          <p>{translation.steps.four[opSys]}</p>
        </li>
        <li>
          <p>{translation.steps.five[opSys]}</p>
        </li>

        {(opSys === "Windows") &&
          <li>
            <p>{translation.steps.six}</p>
          </li>
        }
      </ol>
    </div>;
  }

  renderIsOnVM() {
    const translation = this.props.translation.desktopApp;
    return <div>
      {translation.vmIsOn.body}
    </div>;
  }

  renderHasBlockedApps() {
    const translation = this.props.translation.desktopApp;
    const { syncDocumentData, store } = this.props;
    const { SessionStore } = store;
    // Check if we are running apps that are not allowed
    let blockedApps = [];
    let blockedAppsNames = [];
    if (syncDocumentData
      && syncDocumentData.blockedApplications
      && syncDocumentData.blockedApplications.applications) {
      blockedApps = syncDocumentData.blockedApplications.applications;
      if (blockedApps.length > 0) {
        for (const blockedApp of blockedApps) {
          if (blockedAppsNames.indexOf(blockedApp.applicationName) === -1) {
            blockedAppsNames.push(blockedApp.applicationName);
          }
        }
      }
    }
    if(this.state.loading){
      return <div>{translation.blockedApps.closingMessage}</div>
    }
    return <div>
      <p>{translation.blockedApps.body} </p>
      <button className={'btn'}
              style={{ width: 300, margin: '10px 0' }}
              onClick={() => {
                this.setState({loading: true})
                SessionStore.desktopAppCloseBlockedApps(()=>{
                  // Force update and timeout is to make sure we don't blink the blocked apps screen
                  // after the close has taken place
                  this.forceUpdate();
                  setTimeout(() => this.setState({loading: false}), 1000);
                });
              }}>{translation.blockedApps.button}
      </button>
      <p>{translation.blockedApps.listTitle} </p>
      <ul>
        {
          blockedAppsNames.map(( applicationName ) => {
          return <li>{applicationName}</li>;
        })}
      </ul>
    </div>;
  }

  renderSuccess() {
    const translation = this.props.translation.desktopApp;
    return <div>
      <p>{translation.success.body} </p>
    </div>;
  }

  renderFragment() {
    const { syncDocumentData, store } = this.props;
    const { SessionStore } = store;
    const {desktopAppConnected} = SessionStore;
    // Check if we are running apps that are not allowed
    const hasBlockedApps = syncDocumentData
      && syncDocumentData.blockedApplications
      && syncDocumentData.blockedApplications.applications
      && syncDocumentData.blockedApplications.applications.length > 0;

    // Check if we are running on a vm
    const isRunningOnVm = syncDocumentData
      && syncDocumentData.vmDetected
      && syncDocumentData.vmDetected.vm === true;

    const timeAgo = moment().subtract(minutesAgoToCheck, 'minutes');
    // Check if the desktop app wrote to the sync doc at all
    // If we dont have the time stamps the desktop app didnt do the checks yet
    const desktopAppChecksReady = syncDocumentData
      && syncDocumentData.vmDetected
      && syncDocumentData.vmDetected.timestamp
      && moment(syncDocumentData.vmDetected.timestamp).isAfter(timeAgo)
      && syncDocumentData.blockedApplications
      && moment(syncDocumentData.blockedApplications.timestamp).isAfter(timeAgo)
      && desktopAppConnected;

    if (!desktopAppChecksReady) {
      return this.renderInstructions();
    }

    if (isRunningOnVm) {
      return this.renderIsOnVM();
    }

    if (hasBlockedApps) {
      return this.renderHasBlockedApps();
    }

    return this.renderSuccess();
  }

  render() {
    const { statusClass } = this.props;

    return (
      <div className={`panel panel--medium ${statusClass}`}>
        {this.renderFragment()}
      </div>
    );
  }

};

export default DesktopApp;



// WEBPACK FOOTER //
// ./src/app/components/SessionStart/DesktopApp.js